/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询当前剧院活动下的所有可用优惠券
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.CouponDetailDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/theater-activity-coupons`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
